import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import useAxios, { axiosInstance } from '../../../../../hooks/useAxios'
import { IDistributionChannel } from '../../../../../types/distribution-channel'
import CircularLoading from '../../../../../components/CircularProgress'
import { IOrder } from '../../../../../types/order'
import SelectSearch, {
  IOptionSelect,
} from '../../../../../components/SelectSearch'
import { PaginationResponseInterface } from '../../../../../types/pagination'
import { ImageLinks, LogoTypeSocial } from '../../../../../constants/image-link'
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors'
import ChannelSelectSearch from '../../../../../components/SelectSearch/ChannelSelectSearch'

interface IOrderEditDistributionFormModalProps {
  isOpen: boolean
  onClose: (visible: boolean) => void
  order?: IOrder
  onSuccess: () => void
}

interface IDistributionFormModal {
  distribution: string
}

const getDistributionFormValidationSchema = () => {
  return Yup.object({
    distribution: Yup.string().required('กรุณาเลือกช่องทางการขาย'),
  })
}

export const OrderEditDistributionFormModal = (
  props: IOrderEditDistributionFormModalProps,
) => {
  const { isOpen, onClose, order, onSuccess } = props
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [searchDistributionChannel, setSearchDistributionChannel] =
    useState<string>('')

  const distributionChannels = useAxios<
    PaginationResponseInterface<IDistributionChannel>
  >({
    method: 'GET',
    url: '/distribution-channels',
    params: {
      page: 1,
      perPage: 5,
      name: searchDistributionChannel,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchDistributionChannel = async (value: string) => {
    setSearchDistributionChannel(value)
    await distributionChannels.mutate()
  }

  useEffect(() => {
    setIsLoading(true)
    formik.setValues({
      distribution: order?.distribution?.name ?? '',
    })
    setIsLoading(false)
  }, [isOpen, order])

  const formik = useFormik<IDistributionFormModal>({
    initialValues: {
      distribution: '',
    } as IDistributionFormModal,
    validationSchema: getDistributionFormValidationSchema(),
    onSubmit: async (values: IDistributionFormModal) => {
      setIsLoading(true)
      try {
        await axiosInstance.put(`/order/${order?.objectId}/payment`, {
          distribution: values.distribution,
          paymentMethod: order?.paymentMethod,
          orderDate: order?.orderDate,
          paymentDate: order?.paymentDate,
          paymentUrl: order?.paymentUrl,
          note: order?.note,
        })
        message.success(`แก้ไขการชำระเงิน สำเร็จ`)
        formik.resetForm()
        onClose(false)
        onSuccess()
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
      setIsLoading(false)
    },
  })

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} maxWidth="xl">
      <CircularLoading isLoading={isLoading} />
      <DialogTitle>แก้ไขการชำระเงิน</DialogTitle>
      <DialogContent>
        <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} lg={12}>
              {/* <SelectSearch<IDistributionChannel>
                label={'เลือกช่องทางการขาย'}
                onSelect={(e) =>
                  formik.setFieldValue('distribution', e?.value.objectId)
                }
                search={searchDistributionChannel}
                onSearch={handleSearchDistributionChannel}
                name="distribution"
                helperText={
                  formik.touched.distribution &&
                  (formik.errors.distribution as string)
                }
                error={
                  !!(formik.touched.distribution && formik.errors.distribution)
                }
                onBlur={formik.handleBlur}
                options={
                  distributionChannels.data?.records.map(
                    (distributionChannel: IDistributionChannel) => ({
                      label: distributionChannel.name,
                      image:
                        ImageLinks[
                          `LOGO_${distributionChannel.type.toUpperCase()}` as LogoTypeSocial
                        ],
                      value: distributionChannel,
                    }),
                  ) || ([] as IOptionSelect<IDistributionChannel>[])
                }
              /> */}
              <ChannelSelectSearch
                multiple={false}
                label={'เลือกช่องทางการขาย'}
                onSelect={(e) =>
                  formik.setFieldValue('distribution', e?.value.objectId)
                }
                name="distribution"
                helperText={
                  formik.touched.distribution &&
                  (formik.errors.distribution as string)
                }
                error={
                  !!(formik.touched.distribution && formik.errors.distribution)
                }
                onBlur={formik.handleBlur}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2} justifyContent={'flex-end'}>
            <Grid item>
              <Button
                disabled={formik.isSubmitting}
                startIcon={
                  formik.isSubmitting ? (
                    <CircularProgress size={18} />
                  ) : (
                    <SaveIcon />
                  )
                }
                color="primary"
                type="submit"
                size="large"
                variant="contained"
              >
                แก้ไขช่องทางการขาย
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="inherit"
                size="large"
                variant="contained"
                onClick={() => onClose(false)}
                startIcon={<ClearIcon />}
              >
                ปิดหน้าต่าง
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
